<div id="embed-target" #embedTarget> 

</div>
<!-- <button (click)="payWithEmbeddedPage()" class="border-l-rose-600 p-3">Pay with Embedded Page</button>
<button (click)="payWithPaymentPage()" class="border-l-rose-600 p-3">Pay with Payment Page</button> -->